import axios from "axios";
import config from "../Utility/ConfigUtility";
import { paramsInQueryStringFormat } from "../Utility/ServiceUtility";
import { alert } from "../Components/Shared/AlertUtility";
import "../Components/Shared/TokenInterceptor";

const FileEndpoints = {
    getFiles: (parentFileId, parentFileTitle, title, isSelectAll = false) => axios.get(`${config.apiUrl}/files${paramsInQueryStringFormat({ parentFileId, parentFileTitle, title, isSelectAll }) }`),
    download: (id) => axios.get(`${config.apiUrl}/files/${id}/download`, { responseType: 'arraybuffer' }),
    preview: (id) => axios.get(`${config.apiUrl}/files/${id}/download`),
    alert
};

export default FileEndpoints;
